var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.competitiveMarketItems.length)?_c('div',[_c('b-table',{staticClass:"fraudReportHeaderTable",attrs:{"responsive":"","striped":"","bordered":"","fields":_vm.competitiveMarketFields,"items":_vm.competitiveMarketItems}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }